import {
  IWidgetComponentProps,
  RichTextAdvancedRender,
  getWidgetProps,
} from '@framework/engine';
import React from 'react';
import { isOmissisEnabled } from '../../directives/omissis/OmissisDirective.type';
import {
  IUploadWidget,
  UploadButtonsLayout,
  UploadWidgetKind,
} from './IUploadWidget';
import { ButtonsLayout } from './components/ButtonsLayout';
import { UploadWidgetPreviewInput } from './components/UploadWidgetPreviewInput';

export interface IUploadWidgetPreviewProps
  extends IWidgetComponentProps<IUploadWidget> {}

export function UploadWidgetPreview(props: IUploadWidgetPreviewProps) {
  const { widget } = props;
  const options = getWidgetProps(props);

  const isButton = widget.kind === UploadWidgetKind.Button;

  // Check se è richiesto il "doppio upload" per i dati sensibili
  const sensitiveDataUpload = widget.directives?.omissis?.enabled ?? false;

  //TODO: implement file type Testo da mostrare
  // const accept = widget.rules?.fileType?.value.join(', ') ?? undefined;

  const title = widget.title ? (
    <RichTextAdvancedRender text={widget.title} />
  ) : undefined;

  const publicTitle = widget.publicUploadTitle ? (
    <RichTextAdvancedRender text={widget.publicUploadTitle} />
  ) : undefined;

  return (
    <ButtonsLayout
      hasOmissis={isOmissisEnabled(widget)}
      horizontal={widget.layout?.buttonLayout == UploadButtonsLayout.Horizontal}
    >
      <UploadWidgetPreviewInput
        options={options}
        isButton={isButton}
        title={title}
        helpText={options.helpText}
        label={options.label}
      />
      {sensitiveDataUpload && (
        <UploadWidgetPreviewInput
          options={options}
          isButton={isButton}
          title={publicTitle}
          helpText={widget.publicHelpText}
          label={widget.publicUploadLabel}
        />
      )}
    </ButtonsLayout>
  );
}
